<template>
  <div class="img-wrapper">
    <img src="@/assets/offline.png" alt="" class="img" />
    <span class="text">落地页下线啦...</span>
  </div>
</template>

<script>
export default {
  name: "offline",
};
</script>

<style lang="less" scoped>
.img-wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #FFF;
  padding-top: 40%;
  box-sizing: border-box;
  .img {
    width: 80%;
  }
  .text{
    color: #8b8a8a;
    font-size: 16px;
    margin-top: 30px;
  }
}
</style>
